/* eslint-disable */
import {
	useMemo
} from 'react';
import { connect } from 'react-redux';
import { Button } from '@/Components/ui/button';
import GlobalSearch from '@/Components/globalSearch/search';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';

function ProductPlanHeader(props) {
	const {
		openModal = () => { },
		openLongTermModal = () => { },
		isA2bCustomer = false,
		toggleFiltersDrawer,
		handleSearch = () => { },
		level = null,
		openBuyerModal = () => { },
		isShowMultiple = false,
	} = props;


	// Search dropdown options
	const searchDropDownOptions = useMemo(() => {
		return [
			{
				label: 'Plan Name',
				value: 'planName',
				placeholder: 'Search by Plan Name...',
			},
			{
				label: 'Plan ID',
				value: 'planId',
				placeholder: 'Search by Plan ID...',
			},
		];
	}, []);

	return (
		<>
			<div className='flex flex-col gap-2 p-4'>
				<div className='flex justify-between'>
					<p className='text-[20px] font-semibold' >Production Plans</p>
					{level !== 1 && (
						<div className='flex items-center gap-3'>
							{!isShowMultiple && (
								<>
									<Button
										onClick={openBuyerModal}
										className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
									>
										+ Create Multiple Buyer Order
									</Button>
									<Button
										onClick={openLongTermModal}
										className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
									>
										+ Long Term Plan
									</Button>
								</>
							)}
							{isA2bCustomer && (
								<Button
									onClick={openModal}
									className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
								>
									+ Create Multiple Order
								</Button>
							)}
						</div>
					)}
				</div>
				<div className='flex items-center gap-2 mt-2'>
					<GlobalSearch
						dropDownOptions={searchDropDownOptions}
						searchDropDown={true}
						setSelectedValue={handleSearch}
						placeholderText='Search...'
					/>
					<Button
						onClick={() => toggleFiltersDrawer(true)}
						className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
					>
						<span className='text-nowrap'>Filter & Export</span>
						<Filter className='size-4' />
					</Button>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = {
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPlanHeader);
